import React, {Fragment, useState} from 'react';
import {Grid} from "@mui/material";
import MessageList from "../MessageList";
import ReactPaginate from "react-paginate";
import {useSelector, useDispatch} from "react-redux";
import MetricsConversation from "../MetricsConversation";
import {metricsActions} from "_actions";
import MetricsMessageListEmptyState from "../EmptyStatesAndLoaders/MetricsMessageListEmptyState";
import {MetricsMessageListLoader} from "../EmptyStatesAndLoaders/MetricsMessageListLoader";
import {MetricsConversationLoader} from "../EmptyStatesAndLoaders/MetricsConversationLoader";
import _ from "lodash";
import {isOEmbedSupported} from "../../Vote/Sections/BodySection/Conversation/OEmbed/EmbedUtils";
import ConversationCarousel from "../../Vote/Sections/BodySection/Conversation/ConversationCarousel";
import {shouldDisplayInApp} from "_helpers";
import styles from "../Utilities/Styles.module.css"

const MetricsMessagesBox = ({messageList, allMessagesCount, eachPageMessagesCount, selectedChannels, pageParams, setPageParams, pageFilter, loading}) => {
    const state = useSelector((state) => state.metrics)
    const conversationThread = state.metricsDetailConversation || [];
    const messageProps = state.messageProps;
    const csatList = state.csatList
    const loadingConversation = state.loadingMetricsDetailConversation
    const dispatch = useDispatch();
    const [messageLink, setMessageLink] = useState("");
    const [messageSource, setMessageSource] = useState("");
    const [messageClicked, setMessageClicked] = useState(false);

    const handlePageSelect = (page) => {
        if (conversationThread?.length > 0) {
            dispatch(metricsActions.clearConversation())
        }
        setPageParams({offset: parseInt(page.selected,10) * 10, currentPage: parseInt(page.selected, 10)})
    }
    const getNextPage = () => {
        const queryOffset = parseInt(pageParams.offset, 10);
        const queryMax = parseInt('10', 10);
        eachPageMessagesCount = parseInt(eachPageMessagesCount, 10)

        if (!eachPageMessagesCount) return 0;

        if ([0, 10, 20, 30, 40, 50, 60, 70, 80, 90].includes(queryOffset) && eachPageMessagesCount === 10) {
            return eachPageMessagesCount + 1;
        } else if (eachPageMessagesCount / queryMax === 1) {
            return (queryOffset / eachPageMessagesCount) + 2;
        } else if (eachPageMessagesCount / queryMax < 1) {
            return (queryOffset / queryMax) + 1;
        } else {
            return 100 // fallback
        }
    };

    const totalPages = getNextPage();
    const messageCountStart = pageParams.offset + 1;
    const totalMsgsCount = allMessagesCount
    const messageCountEnd = pageParams.offset + eachPageMessagesCount
    const {msgSource, handleTypeName, externalParentId} = messageProps;
    const displayInApp = shouldDisplayInApp(msgSource, handleTypeName);
    const showCarousel = isOEmbedSupported(msgSource, displayInApp);
    let firstMessage = conversationThread[0] || {};
    firstMessage = Object.assign(firstMessage, {msgSource, externalParentId});

    function Content() {
        return(
            conversationThread?.length > 0 && conversationThread.map((conversation, index) =>
                <MetricsConversation
                    key={_.get(conversation, 'id')}
                    message={conversation}
                    pageFilter={pageFilter}
                    nextMessage={index + 1 < conversationThread.length ? conversationThread[index + 1] : null}
                    csatList={csatList}
                    msgSource={messageSource}
                />
            )
        )
    }

    return(
        <Fragment>
            <div className={styles.rootWrapper}>
                <Grid container>
                    <Grid item xs={12} sm={12} md={5} lg={5} sx={{width: '543px'}}>
                        <div className={styles.msgBoxLeftContainer}>
                            <div className={styles.leftContainerHeading}>
                                <span className={styles.boxHeading}>INCOMING MESSAGES</span>
                            </div>
                            <div className={styles.msgListContainer}>
                                {loading ? <MetricsMessageListLoader/> :
                                    <div className={styles.msgListInnerPuhcd}>
                                        {messageList && messageList.length === 0 ?
                                            <MetricsMessageListEmptyState/> :
                                            messageList &&
                                            <MessageList
                                                msgList={messageList}
                                                selectedChannels={selectedChannels}
                                                setMessageLink={setMessageLink}
                                                setMessageSource={setMessageSource}
                                                loading={loading}
                                                setMessageClicked={setMessageClicked}
                                            />
                                        }
                                    </div>
                                }
                            </div>

                            <div className={styles.paginationContainer}>
                                <span className={'fustat-medium'}> {allMessagesCount ? `${messageCountStart} - ${messageCountEnd} of ${totalMsgsCount}` : ""}</span>
                                {totalPages > 1 &&
                                    <div className="md-pagination numberless-pagination">
                                        <div className={styles.font14}>
                                            <ReactPaginate
                                                previousLabel={"<"}
                                                nextLabel={">"}
                                                pageClassName="page-item-none"
                                                pageCount={totalPages}
                                                marginPagesDisplayed={0}
                                                disableInitialCallback
                                                pageRangeDisplayed={2}
                                                forcePage={pageParams.currentPage}
                                                onPageChange={page => handlePageSelect(page)}
                                                containerClassName={"pagination"}
                                                subContainerClassName={"pages pagination"}
                                                activeClassName={"active"}
                                                breakClassName="page-item-none"
                                                previousClassName={`previous ${pageParams.currentPage === 1 ? "disabled" : ""}`}
                                                nextClassName={`next ${pageParams.currentPage === totalPages ? "disabled" : ""}`}
                                            />
                                        </div>
                                    </div>
                                }
                            </div>
                        </div>
                    </Grid>

                    <Grid item xs={12} sm={12} md={7} lg={7} sx={{width: '802px'}}>
                        <div className={styles.msgBoxRightContainer}>
                            <div className={styles.rightContainerHeading}>
                                <span className={styles.boxHeading}>CONVERSATION</span>
                            </div>
                            <div className={styles.msgListContainer}>
                                { messageClicked && loadingConversation ?
                                    <MetricsConversationLoader
                                        pageFilter={pageFilter}
                                    /> :
                                    <div className={styles.rightMsgListInner}>
                                        {
                                            showCarousel ?
                                                <ConversationCarousel
                                                    InAppContent={Content}
                                                    message={firstMessage}
                                                    loading={loadingConversation}
                                                    isScrollComplete={true}
                                                    usePadding={true}
                                                /> :
                                                <Content />
                                        }
                                    </div>
                                }
                            </div>

                            <div>
                                <div className={styles.viewSourceContainer}>
                                    {conversationThread?.length > 0 &&
                                        <a className="viewInSourceLink" target="_blank" rel="noreferrer noopener nofollow" href={messageLink}>
                                            View in <span className="viewInSourceLink text-transform-capitalize">{messageSource}</span>
                                        </a>
                                    }
                                </div>
                            </div>
                        </div>
                    </Grid>
                </Grid>
            </div>
        </Fragment>
    )
}

export {MetricsMessagesBox};